import angular from 'angular';

import CheckboxComponent from './checkbox.cmpt';

export default angular
    .module('application.component.checkbox', [])
    .component(CheckboxComponent.selector, CheckboxComponent);



// WEBPACK FOOTER //
// ./src/application/component/checkbox/index.js